export default function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// /home/homechange/domains/homechange.plug-in.es/public_html/wp-content/themes/templatePLG/node_modules/swiper/core/classes/removeClasses.js
// module id = 155
// module chunks = 0